import React from "react"
import { Container, Row, Col } from "reactstrap"
import Heading from "../../../components/shared/heading"
import Text from "../../../components/shared/text"
import { PageContentWrap, PageContent } from "./page-content-area.stc"

const PageContentArea = props => {
  const { heading, content } = props
  const { headingCSS, textCSS } = props
  return (
    <PageContentWrap>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            {content && (
              <PageContent>
                {heading && <Heading {...headingCSS}>{heading}</Heading>}
                {/* todo: mgo - remove this cleanly */}
                {content && <Text {...textCSS}>{content}</Text>}
              </PageContent>
            )}
            {props.children && props.children}
          </Col>
        </Row>
      </Container>
    </PageContentWrap>
  )
}

PageContentArea.defaultProps = {
  headingCSS: {
    as: "h4",
    color: "secondaryColor",
    lineHeight: 1.375,
    mb: "17px",
  },
  textCSS: {
    mb: "26px",
  },
}

export default PageContentArea
